import { render } from "./InfoTooltip.vue?vue&type=template&id=1c873e6c"
import script from "./InfoTooltip.vue?vue&type=script&lang=js"
export * from "./InfoTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__